<script lang="ts">
  import PreviewContent from "$lib/admin/components/content/PreviewContent.svelte";
  import {
    postData,
    postBanners,
    postUsers,
    projectToplists,
    orgOperators,
    orgCasinoGames,
    orgGameProviders,
    lotteryResults,
    project,
    projectAllToplists,
  } from "$lib/services/store";

  export let data;
  let { post, session, usersData, operatorData } = data;
  $: {
    postUsers.set(data.usersData);
    postData.set(data.post);
    projectToplists.set(data.toplistData);
    postBanners.set(data.bannersData);
    orgOperators.set(data.operatorData);
    orgCasinoGames.set(data.casinoGamesData);
    orgGameProviders.set(data.gameProvidersData);
    lotteryResults.set(data.lotteryResultsData);
    projectAllToplists.set(data.allToplistsData);
  }

  const reviews = $project.data?.categoryPages?.reviews;
  const showStructuredData = reviews && post.slug?.includes(reviews.slug);

  let structuredData;

  if (showStructuredData && post.operator_id) {
    const currentOperator = operatorData.find((operator) => operator.id === post.operator_id);
    const section = currentOperator?.data?.rankingSections?.[$project.settings?.market] ?? {};
    const scores = [
      section.games_sortiment,
      section.games_experience,
      section.support,
      section.payments
    ].filter((v) => v > 0);
    const ranking = scores.length
      ? Math.round((scores.reduce((sum, v) => sum + v, 0) / scores.length) * 10) / 10
      : 0;

    structuredData = {
      "@context": "https://schema.org/",
      "@type": "Review",
      itemReviewed: {
        "@type": "Organization",
        name: `${post.title}`,
        url: `${$project.settings?.url}${post.slug}`,
        image: `${$project.data?.imageFolders?.operators}${post.image_featured}`,
        datePublished: `${post.created_at}`,
        dateModified: `${post.updated_at}`,
        isPartOf: {
          "@id": `${$project.settings?.url}#website`,
        },
        inLanguage: `${$project.settings?.lang}`,
      },
      reviewRating: {
        "@type": "Rating",
        ratingValue: ranking,
        bestRating: 5,
        worstRating: 0,
      },
      author: {
        "@type": "Person",
        name: `${usersData[0]?.full_name}`,
        jobTitle: `${usersData[0]?.data?.[$project.key]?.role}`,
        description: `${usersData[0]?.data?.[$project.key]?.bio}`,
        email: `${usersData[0]?.data?.[$project.key]?.contact_email}`,
        sameAs: `${usersData[0]?.data?.[$project.key]?.linkedin}`,
      },
      publisher: {
        "@type": "Organization",
        name: `${$project.settings?.domain}`,
        url: `${$project.settings?.url}`,
        alternateName: `${$project.name}`,
      },
    };
  }
</script>

<svelte:head>
  <title
    >{post.seo.page_title
      ? post.seo.page_title
      : post.title
        ? `${post.title} - ${$project.name}`
        : "No page title set - " + post.project_key.toUpperCase()}</title>
  <meta
    name="description"
    content={post.seo.meta_description && post.parent_id === $project.data.categoryPages.news.id
      ? post.seo.meta_description.substring(0, 149)
      : post.seo.meta_description
        ? post.seo.meta_description
        : post.content.find((block) => block.blockType === "Intro")
          ? post.content
              .find((block) => block.blockType === "Intro")
              ?.props.content.replace(/(<([^>]+)>)/gi, "")
              .substring(0, 149)
          : post.content.find((block) => block.blockType === "Content")
            ? post.content
                .find((block) => block.blockType === "Content")
                ?.props.content.replace(/(<([^>]+)>)/gi, "")
                .substring(0, 149)
            : "No meta description set"} />

  {#if showStructuredData && post.operator_id}
    {@html `
      <script type="application/ld+json">
        ${JSON.stringify(structuredData)}
      </script>
    `}
  {/if}
</svelte:head>
<PreviewContent {post} {session} />
